<template>
  <b-navbar
    class="static-top shadow TopNav"
    toggleable="lg"
    variant="light"
    type="light"
  >
    <b-navbar-brand :to="{ name: 'home' }">
      <img
        src="../../public/ptt-logo.png"
        alt="PT&T Logo"
        class="d-sm-inline-block mr-1 ptt-logo"
      />
      <span class="font-weight-bold d-sm-none d-inline-block">Timesheet</span>
      <span class="font-weight-bold d-none d-sm-inline-block">Online Timesheet</span>
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <!-- Left nav links -->
      <b-navbar-nav>
        <template v-for="(leftItem, idx) in leftItems">
          <Nav :key="idx" v-bind="leftItem" />
        </template>
      </b-navbar-nav>
      <!-- Right nav links -->
      <b-navbar-nav
        v-if="rightItems && rightItems.length"
        class="ml-auto"
      >
        <template v-for="(rightItem, idx) in rightItems">
          <Nav :key="idx" v-bind="rightItem" />
        </template>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Nav from '@/components/Nav';

export default {
  name: 'TopNav',
  components: {
    Nav,
  },
  data() {
    return {};
  },
  computed: {
    leftItems() {
      if (this.isLoggedIn) {
        if (!this.initPassword) {
          return [];
        }

        // TODO: fetch menu items from DB (also depends on permissions)
        const items = [
          {
            label: 'My Timesheet',
            link: { name: 'home' },
            active: this.navIsActive('home'),
          },
          {
            label: 'Forms',
            children: [
              {
                label: 'Overtime Form',
                link: { name: 'overtime' },
              },
              {
                label: 'OB Form',
                link: { name: 'ob' },
              },
            ],
          },
          {
            label: 'My Requests',
            link: { name: 'requests.index' },
            active: this.navIsActive('requests.index'), // OT is default active tab
          },
        ];

        const forApprovalPage = {
          label: 'For Approval',
          link: { name: 'for-approval' },
          active: this.navIsActive('for-approval'),
        };
        // if approver (with timesheet/requests)
        if (this.isApprover) {
          items.push(forApprovalPage);
          // if Approver (no timesheet/requests)
        } else if (this.isApproverNoRequest) {
          return [forApprovalPage];
        }

        if (this.isAdmin) {
          return [
            {
              label: 'Audit Log',
              link: { name: 'audit-log' },
              active: this.navIsActive('audit-log'),
            },
            {
              label: 'System Maintenance',
              link: { name: 'maintenance' },
              active: this.navIsActive('maintenance'),
            },
            {
              label: 'Approved Timesheet',
              link: { name: 'timesheet.approved' },
              active: this.navIsActive('timesheet.approved'),
            },
            {
              label: 'Reports',
              link: { name: 'reports' },
              active: this.navIsActive('reports'),
            }];
        }

        return items;
      }

      return [];
    },
    rightItems() {
      if (this.isLoggedIn) {
        const dropList = [
          {
            label: 'Account',
            link: { name: 'user.account' },
            hidden: !this.initPassword,
          },
          {
            label: 'Logout',
            // link: { name: 'logout' },
            link: '#',
            onClick: this.logoutClick,
          },
        ];

        if (this.isAdmin) {
          dropList.splice(1, 0, {
            label: 'Settings',
            link: { name: 'settings' },
          });
        }

        return [
          {
            right: true,
            label: this.userData.username,
            modifiers: 'text-black',
            children: dropList,
          },
        ];
      }
      return [
        {
          label: 'Login',
          link: { name: 'login' },
        },
      ];
    },
    ...mapGetters([
      'isLoggedIn',
      'userData',
      'isAdmin',
      'isApprover',
      'isApproverNoRequest',
      'initPassword',
    ]),
  },
  methods: {
    logoutClick() {
      this.logout();
      window.location.reload();
    },
    ...mapActions([
      'logout',
    ]),
  },
};
</script>
<style lang="scss">
.TopNav{
  .ptt-logo {
    width: 100px;
  }
}
</style>
